<script setup lang="ts">
import type { Praeparat } from "@/types/otc/praeparat";
import { useOverviewImage } from '../composables/useOverviewImage';

/**
 * Produktbild-Komponente mit automatischer Größenanpassung
 * Zeigt Produktbilder mit Fallback für fehlende Bilder
 */

interface Props {
  praeparat: Praeparat | null;
}

const props = defineProps<Props>();

const {
  finalImageUrl,
  altText,
  hasImage
} = useOverviewImage(props);
</script>

<template>
  <div class="search-result-item-image">
    <img
        v-if="hasImage"
        class="img-fluid product-image"
        :src="finalImageUrl"
        :alt="altText"
        loading="lazy"
    />
    <div v-else class="placeholder-image">
      <span class="placeholder-text">Kein Bild vorhanden</span>
    </div>
  </div>
</template>

<style scoped>
</style>